import { LOAD_STATE } from '@/shared/types'
import { getUserComplaintDetailApi } from '@/server'
import type { GetUserComplaintParams, UserComplaintDetailResponse } from '@/server/types'
import { type OmitPageParam, usePagination } from '@/composables/usePagination'

export function logicComplaintList() {
  const data = ref<UserComplaintDetailResponse[]>([])
  const pagination = usePagination({
    type: 'up',
    pageSize: 20,
    key: `用户相关投诉列表`,
    request: (page, params: OmitPageParam<GetUserComplaintParams> = { userId: -1 }) => getUserComplaintDetailApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: OmitPageParam<GetUserComplaintParams>) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }
  return {
    data,
    pagination,
    getPage,
    state: computed(() => pagination.pagination.status),
  }
}
